define('pages/main/loader',["jquery", "appquery", "app", "modules/layout", "modules/setup", "modules/svgToImage", "modules/worker"], function($, $$, App, Layout, Setup, SvgToImage, Worker) {
    $$ = $$('loader');

    function Progress(onComplete) {
        this.progress = 0;
        this.bar = $$('#progress');
        this.title = $$('#message');
        this.percent = $$('#percent');
        this.stopped = false;
        this.message = function(input) {
            this.title.text(input);
        };
        this.update = function(input, final) {
            var that = this;
            if(this.progress == 100 || this.stopped) {
                return;
            }

            this.progress = final ? input : this.progress + input;
            this.progress = this.progress > 100 ? 100 : this.progress;
            this.percent.text(parseInt(this.progress));
            window.requestAnimationFrame(function() {
                that.bar.width(that.progress + '%');
            });
            if(that.progress == 100) {
                setTimeout(function() {
                    onComplete();
                }, 600);
            }
        };
        this.stop = function() {
            this.stopped = true;
        };
    }

    function throwError(message) {
        App.page.render('message', '<h4>' + message + '</h4>');
    }

    var getSvgImages = (function() {
        var maxzoom = 4;
        return function getSvgImages(svg, dimensions, accumulator, callback, currentzoom) {
            currentzoom = currentzoom || 2;
            dimensions.scale = currentzoom;

            SvgToImage.toDataURI($(svg)[0], dimensions, function(svgImage) {
                accumulator['svg_' + currentzoom + 'x'] = svgImage;
                if(currentzoom < maxzoom) {
                    getSvgImages(svg, dimensions, accumulator, callback, currentzoom + 1);
                } else {
                    callback();
                }
            });
        };
    })();

    return {
        init : function(data) {
            data = data || {load: null};

            var store = App.global('store');
            var percentProgress = {
                'products' : !data.load ? 10 : 30,
                'productsDB' : 70,
                'layout' : !data.load ? 10 : 40,
                'design' : !data.load ? 10 : 60,
            };
            var progress = new Progress(function() {
                Setup.checkLocationAndReload();
            });

            progress.message('Fetching data for the store..');

            if(!data.load || data.load == 'products') {
                var productPromise = new Promise(function(resolve, reject) {
                    App.api.call('/store.getProducts', {'id': store}, function(response) {
                        App.database.set('products', response.data.map(function(p) {
                            return {
                                id : p.id,
                                name : p.name
                            };
                        })).then(function(){
                            resolve(response.data);
                        });
                    }, function(message){
                        progress.stop();
                        throwError(message);
                    }).always(function() {
                        progress.update(percentProgress.products);
                    });
                });

                productPromise.then(function(products) {
                    if(!products.length) {
                        progress.update(percentProgress.productsDB);
                        return;
                    }

                    var batchLength = 50;
                    var addProducts = (function() {
                        var addedProducts = 0;
                        var productCount = products.length;
                        var progressPerWorker = percentProgress.productsDB/Math.ceil(productCount/batchLength);

                        return function () {
                            var count = products.length;
                            if(count) {
                                if(count > batchLength) {
                                    count = batchLength;
                                }
                                var store = products.splice(0, count);
                                App.database.instance.products.bulkPut(store).then(function(){
                                    addedProducts += count;
                                    progress.message('Fetching Products : ' + addedProducts + ' / ' + productCount);
                                    progress.update(progressPerWorker * (count / batchLength));
                                    addProducts();
                                });
                            } else {
                                progress.update(100, true);
                            }
                        };
                    })();
                    addProducts();
                });
            }

            if(!data.load || data.load == 'layout') {
                var layoutPromise = new Promise(function(resolve, reject) {
                    App.api.call('/store.getLayout', {id : store }, function(response) {
                        resolve(JSON.parse(response.layout));
                    }, function(message){
                        progress.stop();
                        throwError(message);
                    }).always(function() {
                        progress.update(percentProgress.layout);
                    });
                });

                layoutPromise.then(function(layoutData) {
                    progress.message('Generating Floor Map...');
                    var mapLayout = {
                        'map_floors' : [],
                        'map_racks' : {},
                        'map_utilities' : {},
                    };

                    var completed = 0;
                    var initiated = 0;
                    $.each(layoutData, function(key, value) {
                        var floor = Number(key.split('-')[1]);
                        var layout = Layout.lay('floorMap', value);
                        var mapKey = 'map_floor_' + floor;

                        mapLayout.map_floors.push(floor);
                        $.each(layout.utilities, function(key, value) {
                            mapLayout.map_utilities[floor + '-' + key] = value;
                        });
                        $.each(layout.racks, function(key, value) {
                            mapLayout.map_racks[floor + '-' + key] = value;
                        });

                        mapLayout[mapKey] = {
                            'units': layout.unit,
                            'canvas': value.fills,
                            'dimensions': layout.dimensions,
                            'svg' : layout.svg
                        };

                        //Convert svg to image using canvas
                        (function(svg, dimensions) {
                            initiated++;
                            getSvgImages(svg, dimensions, mapLayout[mapKey], function() {
                                completed++;
                                if(completed == initiated) {
                                    App.database.set(mapLayout).then(function(){
                                        progress.update(percentProgress.design);
                                    });
                                }
                            });
                        })(layout.svg, $.extend({}, layout.dimensions));
                    });
                });
            }
            var icons = /*icons*/"back_arrow,explore,fire_exit,go_down,go_up,hc_logo,locate,locate_store_icon,more_logo,search,search_small,trolleys,washrooms,zopnow_counters,zopsmart_logo"/*icons*/;
            icons = icons.split(',').map(function(icon) {
                if(STATIC_URL.indexOf('http') > -1) {
                    return STATIC_URL + 'images/icons/' + icon + '.svg';
                }
                return 'http:' + STATIC_URL + 'images/icons/' + icon + '.svg';
            });
            var workerPromise = new Promise(function(resolve, reject) {
                $.get(STATIC_URL + "js/workers/fetchImages.js", function(data) {
                    var blob = new Blob([data], { type: "text/javascript" });
                    resolve(self.URL.createObjectURL(blob));
                });
            });
            workerPromise.then(function(workerUrl) {
                function openWorkers() {
                    Worker.openWorker({
                        url : workerUrl,
                        message : icons,
                        onmessage : function(e) {
                                e.data.map(function(icon) {
                                    var iconName = 'icon-' + icon.icon.match(/\/icons\/.*\.svg$/)[0].substr(7);
                                    return App.database.set(iconName, icon.uri, true);
                                });
                            }
                    });
                }
                openWorkers();
            });
        },
        footer : false
    };
});

